module.exports = __webpack_public_path__ + "img/redtrash.dc23d495.svg";